<template>
  <InfiniteScrollLoader
    :all-loaded="isAllLoaded"
    :loading="loadingCount > 0"
    @load="loadMore"
  >
    <div ref="grid" class="gallery-view-grid" :style="gridStyles">
      <slot
        name="item"
        v-for="(item, index) in loadedItems"
        :item="item"
        :index="index"
      />
      <slot
        name="loading"
        v-for="n in loadingCount"
        :index="n + loadedItems.length"
      />
    </div>
  </InfiniteScrollLoader>
</template>

<script lang="ts">
import { computed, defineComponent, onMounted, PropType, ref } from "vue"
import InfiniteScrollLoader from "features/common/pagination-and-loader/InfiniteScrollLoader.vue"

export default defineComponent({
  name: "GalleryGridUI",
  components: { InfiniteScrollLoader },
  props: {
    totalCount: {
      type: Number,
      required: true,
    },
    loadedItems: {
      type: Array as PropType<any[]>,
      required: true,
      default: () => [],
    },
    loadingCount: {
      type: Number,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const grid = ref<HTMLDivElement | null>(null)
    const isAllLoaded = computed(
      () => props.loadedItems.length + props.loadingCount >= props.totalCount
    )

    const loadMore = () => {
      emit("load-more")
    }

    const gridStyles = computed(() => {
      return {
        gridTemplateColumns: props.compact
          ? "1fr 1fr 1fr"
          : `repeat(auto-fill, 128px)`,
        gridGap: props.compact ? "4px" : "16px",
      }
    })

    onMounted(() => {
      if (grid.value) {
        emit("grid-mounted", grid.value)
      }
    })

    return {
      isAllLoaded,
      loadMore,
      gridStyles,
      grid,
    }
  },
})
</script>

<style scoped>
.gallery-view-grid {
  display: grid;
  grid-auto-rows: minmax(min-content, max-content);
  justify-content: center;
  transition: 300ms;
}
</style>
